import { ResearchFormIcaro } from 'civil-status/view-models/research-form-icaro';
import { DateTime } from 'luxon';
import * as yup from 'yup';

export const validationSchemaFilterIcaroAct = yup
  .object()
  .shape({
    year: yup.string().nullable(),
    number: yup.string().nullable(),
    dateDeclarationStart: yup.date().typeError('Data non valida').nullable(),
    dateDeclarationEnd: yup
      .date()
      .typeError('Data non valida')
      .nullable()
      .when('dateDeclarationStart', (dateDeclarationStart, formValidationSchema) =>
        dateDeclarationStart && dateDeclarationStart?.toString() !== 'Invalid Date'
          ? formValidationSchema.min(
              DateTime.fromJSDate(dateDeclarationStart),
              'Data deve essere maggiore o uguale della Data dichiarazione da'
            )
          : formValidationSchema
      ),
    dateOperationStart: yup.date().typeError('Data non valida').nullable(),
    dateOperationEnd: yup
      .date()
      .typeError('Data non valida')
      .nullable()
      .when('dateOperationStart', (dateOperationStart, formValidationSchema) =>
        dateOperationStart && dateOperationStart?.toString() !== 'Invalid Date'
          ? formValidationSchema.min(
              DateTime.fromJSDate(dateOperationStart),
              'Data deve essere maggiore o uguale della Data operazione da'
            )
          : formValidationSchema
      ),
  })
  .test('year-number', '', (values) => {
    const valuesCasted = values as unknown as ResearchFormIcaro;

    if (!valuesCasted.number && valuesCasted.year) {
      return new yup.ValidationError(
        'Digitare sia anno che numero dichiarazione',
        undefined,
        'number'
      );
    }

    if (!valuesCasted.number && valuesCasted.year) {
      return new yup.ValidationError(
        'Digitare sia anno che numero dichiarazione',
        undefined,
        'number'
      );
    }

    if (!valuesCasted.year && valuesCasted.number) {
      return new yup.ValidationError(
        'Digitare sia anno che numero dichiarazione',
        undefined,
        'year'
      );
    }
    return true;
  });

export const validationSchemaFilterIcaroPerson = yup
  .object()
  .shape({
    surname: yup.string().nullable().required('Campo obbligatorio'),
    dateBorn: yup.date().typeError('Data non valida').nullable(),
  })
  .test('typePerson', '', (values) => {
    const valuesCasted = values as unknown as ResearchFormIcaro;

    if ((valuesCasted.name || valuesCasted.surname) && !valuesCasted.typePerson) {
      return new yup.ValidationError('Campo obbligatorio', undefined, 'typePerson');
    }
    return true;
  });
